import CreatePublicationContainer from "../containers/CreatePublicationContainer";

const CreatePublicationPage = () => {
  return (
    <CreatePublicationContainer />
  );
};

export default CreatePublicationPage;
